import tr from './tr.json';
import en from './en.json';

export default {
  tr,
  en,
};
